var map = {
	"./book-1.png": 2933,
	"./book-2.png": 2934,
	"./book-3.png": 2935,
	"./book-4.png": 2936,
	"./book-5.png": 2937,
	"./book-6.png": 2938
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;



//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers ^\.\/book\-.*\.png$
// module id = 204
// module chunks = 0